import { FunctionComponent } from "react";
import { Outlet, useNavigation } from "react-router";
import { observer } from "mobx-react-lite";

import { LoadingPage } from "../../Pages/FullScreenInformation";

import "./Content.scss";

const RawContentComponent: FunctionComponent = () => {
  const navigation = useNavigation();

  // NOTE #66797 shows loading page while navigation is in the loading state
  if (navigation.state === "loading") {
    return <LoadingPage />;
  }

  return <Outlet />;
};

export const ContentComponent = observer(RawContentComponent);
